import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageSlotModule } from '@spartacus/storefront';
import { ConfigModule, I18nModule } from '@spartacus/core';
import { PrimengModule } from '../primeng/primeng.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SGRESharedModule } from '../../SGRE-shared/SGRE-shared.module';
import {
  TranslateLoader,
  TranslateModule,
  TranslateService,
  TranslateStore,
} from '@ngx-translate/core';
import { MultiTranslateHttpLoader } from 'ngx-translate-multi-http-loader';
import { HttpBackend } from '@angular/common/http';
import { CustomRouteGuard } from '../../SGRE-shared/services/guard/msal.guard';
import { InviteUserFormComponent } from './Components/invite-user-form/invite-user-form.component';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { INVITE_USER_FEATURE } from './store/invite-user.state';
import {InviteUserEffects} from './store/effects/invite-user.effects'
import { InviteReducer } from './store/reducers';
import { InviteUserEffectsService } from './store/effects/inviteUserEffect.service';


export function HttpLoaderFactory(http: HttpBackend) {
  return new MultiTranslateHttpLoader(http, ['/public/i18n/core/', '/public/i18n/vendors/']);
}

@NgModule({
  declarations: [
    InviteUserFormComponent,
  ],
  imports: [
    CommonModule,
    PageSlotModule,
    PrimengModule,
    FormsModule,
    ReactiveFormsModule,
    SGRESharedModule,
    StoreModule.forFeature(INVITE_USER_FEATURE, InviteReducer),
    EffectsModule.forFeature(InviteUserEffects),
    ConfigModule.withConfig({
      cmsComponents: {
        InviteUserFormComponent: {
          component: () => import('./Components/invite-user-form/invite-user-form.component').then(m => m.InviteUserFormComponent),
          guards: [CustomRouteGuard]
        },
       
      }
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpBackend]
      }
    }),
    I18nModule
  ],
  providers: [
    TranslateService,
    InviteUserEffectsService,
    { provide: TranslateStore }
  ]
})
export class InviteUserModule { }